import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const useRegisterNavigation = () => {
  const [showCouponModal, setShowCouponModal] = useState(false)
  const navigate = useNavigate()

  const navigateToRegister = () => {
    setShowCouponModal(true)
  }

  const closeCouponModal = () => {
    setShowCouponModal(false)
  }

  return {
    showCouponModal,
    navigateToRegister,
    closeCouponModal
  }
}
